import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58ed03ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "content",
  class: "content"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_article" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "box_qr" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 扫码添加小助手，回复“白皮书”"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 获取更多行业干货 ")
], -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode("<PageBreadcrumb backName=\"最新动态\" :backPath=\"$Enum.RouterEnum.News\""),
      _createCommentVNode("                :currentName=\"request.data.detail.title\" />"),
      _createVNode(_component_a_row, { gutter: [20,0] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            xl: 16
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: $data.request.data.detail.title==='',
                paragraph: {rows:8},
                active: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_a_typography_title, { level: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($data.request.data.detail.title), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_a_typography_paragraph, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createElementVNode("blockquote", null, " 发布日期：" + _toDisplayString($data.request.data.detail.time === 0 ? '-' : _ctx.$FN.Time.format($data.request.data.detail.time * 1000)), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createCommentVNode("<a-col :span=\"12\">"),
                            _createCommentVNode("    作者：{{ request.data.detail.author }}"),
                            _createCommentVNode("</a-col>")
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createElementVNode("div", {
                      class: "article",
                      innerHTML: $data.request.data.detail.text
                    }, null, 8 /* PROPS */, _hoisted_4)
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            xl: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: $data.request.data.list.length===0,
                active: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_typography_title, {
                    level: 5,
                    class: "recommend"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 动态推荐 ")
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_a_row, { gutter: [20,0] }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.request.data.list, (item) => {
                        return (_openBlock(), _createBlock(_component_a_col, {
                          xs: 24,
                          sm: 8,
                          xl: 24
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "card",
                              onClick: ($event: any) => ($options.switchDetail(item.article_id))
                            }, [
                              _createElementVNode("i", {
                                style: _normalizeStyle({backgroundImage:`url('${item.article_cover_address}')`})
                              }, null, 4 /* STYLE */),
                              _createVNode(_component_a_typography_title, { level: 5 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.article_title), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ], 8 /* PROPS */, _hoisted_5)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                      }), 256 /* UNKEYED_FRAGMENT */)),
                      _createVNode(_component_a_col, {
                        xs: 0,
                        xl: 24
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("img", {
                              alt: "",
                              src: $data.file.ImageQR
                            }, null, 8 /* PROPS */, _hoisted_7),
                            _hoisted_8,
                            _hoisted_9
                          ])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 512 /* NEED_PATCH */))
}